'use strict';

var jQuery = require('jquery');
window.jQuery = window.$ = jQuery;

import Swiper from 'swiper';
import cropBlock from './crop';
//import adbBlock from './adblock';

require('easy-autocomplete');

let size_block = $('.js-size-block');
let closeAll = function (event) {
    if (size_block.is(":visible")) {
        size_block.toggle()
        $('.wallpaper__download__rbut__select__up').toggleClass('wallpaper__download__rbut__select__up')
    }
};
let body = $(document.body);
body.on('click', closeAll);


let allSwiperMenu = document.querySelectorAll('.js-swiper-select');
if (allSwiperMenu.length > 0) {
    for (let i = 0; i < allSwiperMenu.length; i++) {
        let item = allSwiperMenu[i]
        let swiperMenu = new Swiper(item, {slidesPerView: 'auto', loop: false})

        let selectSwiperMenuItem = $(item).find('.select')
        if (selectSwiperMenuItem && selectSwiperMenuItem.length) {
            swiperMenu.slideTo(selectSwiperMenuItem.index(), 1000)
        }
    }
}


let markBlock
let allMark = document.querySelectorAll('.js-mark');

if (allMark.length > 0) {
    require.ensure([], function () {
        markBlock = require('./mark');

        for (let i = 0; i < allMark.length; i++) {
            markBlock(allMark[i]);
        }
    }, 'mark');
}


let commentMarkBlock;
let allCommentMark = document.querySelectorAll('.js-comment_mark');
if (allMark.length > 0) {
    require.ensure([], function () {
        commentMarkBlock = require('./comment_mark');

        for (let i = 0; i < allCommentMark.length; i++) {
            commentMarkBlock(allCommentMark[i]);
        }
    }, 'comment_mark');
}


let favoriteBlock
let allFavoriteMark = document.querySelectorAll('.js-favorite');

if (allFavoriteMark.length > 0) {
    require.ensure([], function () {
        favoriteBlock = require('./favorite');

        for (let i = 0; i < allFavoriteMark.length; i++) {
            favoriteBlock(allFavoriteMark[i]);
        }
    }, 'favorite');
}

let shareBlock
let allShareBlock = document.querySelectorAll('.js-share');

if (allShareBlock.length > 0) {
    require.ensure([], function () {
        shareBlock = require('./share');

        for (let i = 0; i < allShareBlock.length; i++) {
            shareBlock(allShareBlock[i]);
        }
    }, 'share');
}

let sizeBlock
let allSizeBlock = document.querySelectorAll('.js-size');

if (allSizeBlock.length > 0) {
    require.ensure([], function () {
        sizeBlock = require('./size');

        for (let i = 0; i < allSizeBlock.length; i++) {
            sizeBlock(allSizeBlock[i]);
        }
    }, 'size');
}

let commentBlock
let allCommentBlock = document.querySelectorAll('.js-comment');

if (allCommentBlock.length > 0) {
    require.ensure([], function () {
        commentBlock = require('./comment');

        for (let i = 0; i < allCommentBlock.length; i++) {
            commentBlock(allCommentBlock[i]);
        }
    }, 'comment');
}

let mixBlock
let allMixBlock = document.querySelectorAll('.js-mix-form');

if (allMixBlock.length > 0) {
    require.ensure([], function () {
        mixBlock = require('./mix');

        for (let i = 0; i < allMixBlock.length; i++) {
            mixBlock(allMixBlock[i]);
        }
    }, 'mix');
}


let allCropBlock = document.querySelectorAll('.js-crop');

if (allCropBlock.length > 0) {
    require.ensure([], function () {
        for (let i = 0; i < allCropBlock.length; i++) {
            cropBlock(allCropBlock[i]);
        }
    }, 'crop');
}


// let allAdblockBlock = document.querySelectorAll('.js-adb');
//
// if (allAdblockBlock.length > 0) {
//   require.ensure([], function() {
//     for (let i = 0; i < allAdblockBlock.length; i++) {
//       adbBlock(allAdblockBlock[i]);
//     }
//   }, 'adblock');
// }


let moderatorBlock
let allModeratorBlock = document.querySelectorAll('.js-moderator');

if (allModeratorBlock.length > 0) {
    require.ensure([], function () {
        moderatorBlock = require('./moderator');

        for (let i = 0; i < allModeratorBlock.length; i++) {
            moderatorBlock(allModeratorBlock[i]);
        }
    }, 'moderator');
}


let randomBlock
let allRandomBlock = document.querySelectorAll('.js-random');

if (allRandomBlock.length > 0) {
    require.ensure([], function () {
        randomBlock = require('./random');

        for (let i = 0; i < allRandomBlock.length; i++) {
            randomBlock(allRandomBlock[i]);
        }
    }, 'random');
}

var friendBlock
var allFriendBlock = document.querySelectorAll('.js-friend');

if (allFriendBlock.length > 0) {
    require.ensure([], function () {
        friendBlock = require('./friend');

        for (var i = 0; i < allFriendBlock.length; i++) {
            friendBlock(allFriendBlock[i]);
        }
    }, 'friend');
}

let filterBlock
let allFilterBlock = document.querySelectorAll('.js-filter');

if (allFilterBlock.length > 0) {
    require.ensure([], function () {
        filterBlock = require('./filter');

        for (let i = 0; i < allFilterBlock.length; i++) {
            filterBlock(allFilterBlock[i]);
        }
    }, 'filter');
}

let lastBlock
let allLastBlock = document.querySelectorAll('.js-last');

if (allLastBlock.length > 0) {
    require.ensure([], function () {
        lastBlock = require('./last');

        for (let i = 0; i < allLastBlock.length; i++) {
            lastBlock(allLastBlock[i]);
        }
    }, 'last');
}

let jsExit = $('.js-exit');

if (jsExit.length) {
    jsExit.on({
        click: function (event) {
            firebase.auth().signOut().then(function () {
                location.href = jsExit.attr('href')
            });

            return false
        }
    })
}

let searchBlock;
let allSearch = document.querySelectorAll('.js-search');
if (allSearch.length > 0) {
    require.ensure([], function () {
        searchBlock = require('./search');

        for (let i = 0; i < allSearch.length; i++) {
            searchBlock(allSearch[i]);
        }
    }, 'search');
}

let inbox = document.querySelector('.js-inbox');
if (inbox !== null ) {
    require.ensure([], function () {
         require('./inbox')(inbox);
    }, 'inbox');
}

let auth = document.querySelector('.js-auth');
if (auth !== null ) {
    require.ensure([], function () {
         require('./auth')(auth);
    }, 'auth');
}

let add = document.querySelector('.js-fon_add');
if (add !== null ) {
    require.ensure([], function () {
         require('./fon_add')(add);
    }, 'add');
}

let download_img = document.querySelector('.js-download_img');
if (download_img !== null ) {
    require.ensure([], function () {
         require('./download_img')(download_img);
    }, 'download_img');
}

var searchInput = $('.js-search')
var searchForm = $('.js-search-form');
var options = {
    url: function (phrase) {
        return "/moderator/suggest/tag/";
    },

    getValue: function (element) {
        return element;
    },

    ajaxSettings: {
        dataType: "json",
        method: "GET",
        data: {
            dataType: "json"
        }
    },

    list: {
        onChooseEvent: function () {
            searchForm.submit();
        },
    },

    preparePostData: function (data) {
        data.term = searchInput.val();
        return data;
    },

    requestDelay: 400
};

searchInput.easyAutocomplete(options);
searchInput.on('focus', function () {
    $(this).select().css('color', 'black');
});


require('jquery-tageditor');
require('jquery-tageditor/jquery.tag-editor.min');
require("jquery-ui/ui/widgets/autocomplete");
require("jquery-ui/ui/widgets/draggable");

$('.js-tags').tagEditor({
    forceLowercase: false,
    autocomplete: {'source': '/moderator/suggest/tag/', minLength: 3}
});